module.exports = require('./helpers/bundle-url').getBundleURL('jKRPl') + "help-circle.7cae6c13.png";